var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7422 5.53491C20.377 5.36562 21 5.84468 21 6.50171V17.2869C21 18.2282 20.3437 19.0425 19.4238 19.2419L15.75 20.0369V6.60034L19.7422 5.53491ZM14.25 6.42456V19.825L9.75 17.575V4.17456L14.25 6.42456ZM8.25 17.3992L4.25781 18.4646C3.62308 18.6339 3.00023 18.1556 3 17.4988V6.78687C3.00007 5.85746 3.6408 5.05082 4.5459 4.8396L8.25 3.97437V17.3992Z",
    fill: "#222222",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMap);
export default __webpack_public_path__ + "static/media/show-map.d8e8a3c3e6c0b2882dc104cae2429028.svg";
export { ForwardRef as ReactComponent };